module.exports = __webpack_public_path__ + "static/media/revfin_with_kptl.8f89d03a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/revfin_with_kptl.webp
// module id = 321
// module chunks = 0